/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Home Button
 */

import { Button, ButtonProps } from 'antd';
import { Home as HomeIcon } from '@icon-park/react';
import { Link } from 'react-router-dom';

import { getHomePath } from 'utils/router';

const Home: React.FC<ButtonProps> = (props) => {
	return (
		<Link to={getHomePath()}>
			<Button type='primary' {...props}>
				<HomeIcon /> {'Home'}
			</Button>
		</Link>
	);
};

export default Home;
